<template>
  <el-dialog
    :visible.sync="visible"
    :title="$tc('seminar.edit_positions')"
    width="400px"
    @close="visible = false; $emit('close')"
  >
    <div v-if="participant" class="participant-name">
      {{ participant.member ? `${participant.member.firstName} ${participant.member.lastName}` : '' }}
    </div>
    <el-checkbox-group v-model="selectedPositions">
      <div v-for="pos in SEMINAR_POSITIONS" :key="pos" style="margin-bottom: 8px">
        <el-checkbox :label="pos">{{ $tc('seminar.' + pos) }}</el-checkbox>
      </div>
    </el-checkbox-group>
    <span slot="footer">
      <el-button @click="$emit('close')">{{ $tc('general.cancel') }}</el-button>
      <el-button type="primary" :disabled="selectedPositions.length === 0" @click="save">
        {{ $tc('general.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'
import { SEMINAR_POSITIONS } from './seminarPositions'

export default {
  props: {
    participant: { type: Object, default: null },
    seminar: { type: Object, required: true }
  },

  data () {
    return {
      selectedPositions: [],
      visible: true,
      SEMINAR_POSITIONS
    }
  },

  watch: {
    participant: {
      immediate: true,
      handler (p) {
        this.selectedPositions = (p && p.positions ? [...p.positions] : [])
      }
    }
  },

  methods: {
    save () {
      if (this.selectedPositions.length === 0) return
      this.$store.dispatch('seminars/updateParticipant', {
        id: this.participant.id,
        payload: { positions: this.selectedPositions }
      }).then(() => {
        this.$message.success(this.$tc('messages.success_updated'))
        this.$emit('saved')
        this.$emit('close')
      }).catch(errorHandler)
    }
  }
}
</script>

<style scoped>
.participant-name { margin-bottom: 12px; font-weight: 500; }
</style>
